import { FilterRowSelection } from '../Landing.slice';

export type KeyValue = {
  value: string;
  text: string;
};

type FilterRowAvailableOptions = {
  availableParameters: string[];
  availableOperations: string[];
  availableValues: string[];
  availableConjuctions: string[];
};

export type FilterRow = FilterRowAvailableOptions & FilterRowSelection;

export class FilterConsts {
  static OP_EQUAL: string = '=';
  static OP_NOT_EQUAL: string = '!=';
  static OP_GREATER_THAN_OR_EQUAL: string = '>=';
  static OP_LESS_THAN_OR_EQUAL: string = '<=';
  static availableOperations: string[] = [
    FilterConsts.OP_EQUAL,
    FilterConsts.OP_NOT_EQUAL,
    FilterConsts.OP_GREATER_THAN_OR_EQUAL,
    FilterConsts.OP_LESS_THAN_OR_EQUAL
  ];
  static CONJ_AND: string = 'AND';
  static CONJ_OR: string = 'OR';
  static CONJ_NOT: string = 'NOT';
  static CONJ_END: string = 'END';
  static availableConjunctions: string[] = [FilterConsts.CONJ_AND, FilterConsts.CONJ_OR, FilterConsts.CONJ_END];
}

export const areFiltersInValidState = (filters: FilterRow[]) => {
  const result = filters.map((filterRow, index) => {
    if (index < filters.length - 1) {
      if (filterRow.selectedConjuction === FilterConsts.CONJ_END) {
        return false;
      }
    }

    if (filterRow.selectedConjuction && filterRow.selectedOperation && filterRow.selectedParameter && filterRow.selectedValue) {
      return true;
    }

    return false;
  });

  if (result.some(x => !x)) {
    return false;
  }

  return true;
};

const GUID_PATTERN = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const FINDING_ID_SEPARATOR = ',';

export const areFindingIdsInValidState = (findingIds: string) => {
  const raw = findingIds.replace(' ', '');
  const findingIdArray = raw.split(FINDING_ID_SEPARATOR);
  const result = findingIdArray.map(findingId => GUID_PATTERN.test(findingId));
  if (result.some(x => !x)) {
    return false;
  }

  return true;
};

const BLADE_A = 'A';
const BLADE_B = 'B';
const BLADE_C = 'C';
const LEADING_EDGE = 'LeadingEdge';
const TRAILING_EDGE = 'TrailingEdge';
const PRESSURE_SIDE = 'PressureSide';
const SUCTION_SIDE = 'SuctionSide';

export const AVAILABLE_SEQUENCES = [
  `${BLADE_A}/${LEADING_EDGE}`,
  `${BLADE_A}/${TRAILING_EDGE}`,
  `${BLADE_A}/${PRESSURE_SIDE}`,
  `${BLADE_A}/${SUCTION_SIDE}`,
  `${BLADE_B}/${LEADING_EDGE}`,
  `${BLADE_B}/${TRAILING_EDGE}`,
  `${BLADE_B}/${PRESSURE_SIDE}`,
  `${BLADE_B}/${SUCTION_SIDE}`,
  `${BLADE_C}/${LEADING_EDGE}`,
  `${BLADE_C}/${TRAILING_EDGE}`,
  `${BLADE_C}/${PRESSURE_SIDE}`,
  `${BLADE_C}/${SUCTION_SIDE}`
];
